module.exports = __webpack_public_path__ + "static/media/floors.c99beca8.svg";